import React from 'react';

import { Content } from './Content.js';

export default class ArbitraryHtmlBox extends React.Component {

  render() {
    var contents = {
      __html: Content[this.props.page][this.props.section].html
    };

    return (
      <div className={`ArbitraryHtmlBox row ${this.props.section}`}>
        <div className="col-xs-16" dangerouslySetInnerHTML={contents} data-scroll-item-once></div>
      </div>
    );
  }

};
